// extracted by mini-css-extract-plugin
export default {"wrapper":"description_wrapper__aU5Zz","paragraph":"description_paragraph__4w658"};